/**
 * HTTP layer for a site's sectioned settings document. The odl_app site-settings
 * read/write surface.
 *
 * Contains:
 * - fetchSiteSettings: read a site's settings sections
 * - patchSiteSettings: write a site's settings sections
 */
import apiClient from '@sophocles/http-common';

// Consolidated site-settings endpoint.  See
// `pliny.odl_app.views.site_settings.SiteSettingsViewSet` for the
// backend.  Both the V2 settings page and the revamped quick-edit
// dialog read/write through this single endpoint; the dialog just
// PATCHes the subset of sections it cares about.
const path = siteId => `odl-app/site-settings/${siteId}/`;

export const fetchSiteSettings = siteId => apiClient.get(path(siteId)).then(res => res.data);

export const patchSiteSettings = (siteId, payload) => apiClient.patch(path(siteId), payload).then(res => res.data);
